<template>
  <AppBar />
  <v-main>
    <router-view />
    <FooterComponent />
  </v-main>
  <v-snackbar v-model="snackbar.active" :color="snackbar.color" location="top" :timeout="snackbar.timeout">
    <template #text>
      {{ snackbar.text }}
    </template>
    <template #actions>
      <v-btn color="white" :text="snackbar.action" @click="snackbarAction" />
    </template>
  </v-snackbar>
  <MenuBottom />
</template>

<script lang="ts">
  import AppBar from '@/components/MainPage/AppBar.vue'
  import MenuBottom from '@/components/MainPage/MenuBottom.vue'
  import { useAppStore } from '@/stores/app'

  export default {
    name: 'MainPage',
    components: { AppBar, MenuBottom },
    data: () => ({
      snackbar: {
        active: false,
        color: 'success',
        text: '',
        timeout: 10000,
        action: 'Fechar'
      },
      socketResult: null,
    }),
    created () {
      const store = useAppStore();
      this.socket.on('connect', () => {
        console.log('[Socket] Conectado ao servidor');
      });

      this.socket.on('disconnect', () => {
        console.log('[Socket] Desconectado do servidor');
      });

      this.socket.on('error', (error: any) => {
        console.log(error);
      });

      this.socket.on('generating-pdf', () => {
        store.setIsGeneratingPdf(true);
      });
    },
    methods: {
      snackbarAction () {
        if (this.snackbar.action === 'Abrir PDF') {
          window.open(`${this.getBaseUrl()}/pdfs/${this.socketResult.pdf}`, '_blank');
          this.snackbar.action = 'Fechar';
        }

        if (this.snackbar.action === 'Fechar') {
          this.snackbar.active = false;
        }
      }
    }
  }
</script>

<style scoped>

</style>
